export enum EmptyStatesPath {
  ForbiddenPath = 'forbidden',
  NoAccessPath = 'no-access',
  MissingRolesPath = 'missing-roles',
}
